<template>
  <div v-show="showModal" class="modal-upload">
    <div class="modal-contents">
      <slot name="modal-header">
        <div class="w-100 modal-header-content p-2">
          <h3 class="modal-header-text">Study Edit History</h3>
        </div>
      </slot>
      <slot name="modal-body">
        <div class="w-100 modal-body-content">
          <el-table
            :data="studyEditHistory"
            :border="true"
            :resizable="true"
            :key="studyEditHistory.length"
          >
            <el-table-column label="ID" align="center" width="40">
              <template slot-scope="props">
                {{ studyEditHistory[props.$index]['id'] }}
              </template>
            </el-table-column>
            <el-table-column label="Email" align="center">
              <template slot-scope="props">
                {{ studyEditHistory[props.$index]['user_email'] }}
              </template>
            </el-table-column>
            <el-table-column label="Change Date" align="center">
              <template slot-scope="props">
                {{ getChangeDate(studyEditHistory[props.$index]['change_date']) }}
              </template>
            </el-table-column>
            <el-table-column label="Field" align="center">
              <template slot-scope="props">
                {{ studyEditHistory[props.$index]['field'] }}
              </template>
            </el-table-column>
            <el-table-column label="Old Value" align="center">
              <template slot-scope="props">
                {{ studyEditHistory[props.$index]['old_value'] }}
              </template>
            </el-table-column>
            <el-table-column label="New Value" align="center">
              <template slot-scope="props">
                {{ studyEditHistory[props.$index]['new_value'] }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </slot>
      <slot name="modal-footer">
        <div class="w-100 p-3 mt-3 text-center d-flex">
          <button
            class="search-button btn ml-auto"
            type="button"
            @click="() => Close()"
          >
            Close
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudyEditHistoryModal',
  props: {
    showModal: Boolean,
    studyEditHistory: {
      default: []
    }
  },
  data () {
    return {
      studyEditHistoryColumns: [
        'id',
        'user_email',
        'change_date',
        'field',
        'old_value',
        'new_value'
      ],
      studyEditHistoryHeaders: {
        'id': 'ID',
        'user_email': 'Email',
        'change_date': 'Change Date',
        'field': 'Field',
        'old_value': 'Old Value',
        'new_value': 'New Value'
      }
    }
  },
  methods: {
    Close () {
      this.$emit('close')
    },
    getChangeDate (date) {
      return date.split('T')[0]
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

@keyframes progress-bar-stripes-animation {
  from { background-position: 20px 0; }
  to { background-position: 0 0; }
}

.cancel-btn, .search-button {
  width: 230px;
  height: 48px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 30px;
  letter-spacing: 0;
  border-radius: 4px;
  color: white;
  text-transform: uppercase;
  transition: background-color 0.2s linear;
  background-color: $blueberry;
  &:hover {
    background-color: #9256D9;
  }
}

.modal-upload {
  width: 100%;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .modal-contents {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1000px;
    max-height: 400px;
    background-color: rgb(246, 246, 246);
    padding: 1.5rem;

    .modal-header-content {
      border-bottom: 1px solid lightgray;
      .modal-header-text {
        font-size: 30px;
        color: lightslategrey;
      }
    }

    .modal-body-content {
      height: 250px;
      overflow: auto;
      padding: 1rem 4rem;
      .process-bar-parent {
        border: 1px solid lightgray;
        border-radius: .5rem;
        height: 20px;
        padding: .25rem;
        .process-bar {
          border-radius: .5rem;
          transition: .3s linear;
        }
        .progress-bar-striped {
          background-size: 20px 20px;
          background-image: linear-gradient(45deg, rgba(24, 26, 27, 0.15) 25%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 50%, rgba(24, 26, 27, 0.15) 50%, rgba(24, 26, 27, 0.15) 75%, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0));
        }
        .process-bar__upload {
          background-color: rebeccapurple;
          animation: progress-bar-stripes-animation 1s linear infinite;
        }
        .process-bar__validation {
          background-color: $orange-400;
          animation: progress-bar-stripes-animation 1s linear infinite;
        }
        .process-bar__done {
          background-color: $celery-500
        }
        .process-bar__failed {
          background-color: $red;
        }
      }
    }
  }
}
.custom-font-size {
  font-size: 1em
}

</style>
